export type Emoji = '❤️' | '🔥' | '💦' | '🙉';

export const DEFAULT_EMOJI: Emoji = '❤️';
export const DEFAULT_BACKGROUND_COLOR_HEX: string = '#111827';
export const DEFAULT_SHOW_BUBBLES: boolean = true;

// local storage keys
export const EMOJI_KEY = 'emoji';
export const BACKGROUND_COLOR_HEX_KEY = 'backgroundColor';
export const SHOW_BUBBLES_KEY = 'showBubbles';
